import { render, staticRenderFns } from "./EmployeeTable.vue?vue&type=template&id=4c54fcda"
import script from "./EmployeeTable.vue?vue&type=script&lang=js"
export * from "./EmployeeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports